import { render, staticRenderFns } from "./ApiDialogAdmin.vue?vue&type=template&id=810ca128"
import script from "./ApiDialogAdmin.vue?vue&type=script&lang=js"
export * from "./ApiDialogAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports